export default {
    namespaced  : true,
  
    state       : {
      opendModalCounter : 0,
    },
  
    mutations   : {
      setOpendModalCounter(state, value){
        state.opendModalCounter = value;
      }
    },
  
    actions     : {
      addOpendModal(context){
        const value = context.state.opendModalCounter + 1;
  
        context.dispatch('updateOpendModalCounter', value);
      },
  
      removeOpendModal(context){
        const value = context.state.opendModalCounter - 1;
        
        context.dispatch('updateOpendModalCounter', value);
      },
      
      updateOpendModalCounter(context, value){
        context.commit('setOpendModalCounter', value);
      }
    }
  };